import { Track, Fill } from './share-bar.styles';

// A horizontal bar showing a value's relative scale: the server-computed
// `share` (0–1) rendered as a coloured fill over a track. Used by the
// disclosure by-source / measure-class tables alongside the % text.
//
// Presentational only — `share` and `color` come from the caller; nothing
// is computed here (the FE never derives the share). `aria-hidden` because
// the adjacent % text is the accessible value; the bar is a visual echo.
const ShareBar = (props: ShareBarProps) => {
  const { share, color } = props;
  return (
    <Track aria-hidden='true'>
      <Fill $share={share} $color={color} />
    </Track>
  );
};

export type ShareBarProps = {
  share: number;
  color: string;
};

export { ShareBar };
